export enum EventName {
  // Initialising
  OperatorInitialised = 'OperatorInitialised', // params: operatorId: string

  // App Startup
  AppConstructor = 'App_Constructor',
  AppOnInit = 'App_OnInit',
  FetchTranslation = 'Fetch_Translation',
  FirebaseInitialised = 'Firebase_Initialised',
  BootupRequestSuccess = 'BootupRequestSuccess',

  // Clinch List Page
  ClinchListView = 'ClinchList_View', // params: hasRooms: bool or undefined
  ClinchListCellClick = 'ClinchList_Cell_Click', // param: roomId: string

  // Clinch Pay Page
  ClinchPayCopyInvoiceClick = 'ClinchPay_CopyInvoice Click', // params: roomId: string
  ClinchPayLightningClick = 'Clinch_PayLightning_Click', // params: roomId: string
  ClinchPayNativeWalletClick = 'Clinch_PayNativeWallet_Click', // params: roomId: string
  ClinchPayOperatorLightningClick = 'Clinch_PayOperatorLightning_Click',

  // Clinch Game Page
  ClinchGameView = 'ClinchGame_View', // params: roomId: string
  ClinchGameBackClick = 'ClinchGame_Back_Click', // params: roomId: string
  ClinchGameFinishClick = 'ClinchGame_Finish_Click', // params: roomId: string
  ClinchGameSubmitScoreSuccess = 'ClinchGame_SubmitScore_Success', // params: roomId: string
  ClinchGameSubmitScoreFail = 'ClinchGame_SubmitScore_Fail', // params: roomId: string
  ClinchGameFinishAlertView = 'ClinchGame_FinishAlert_View', // params: roomId: string
  ClinchGameFinishAlertAnswer = 'ClinchGame_FinishAlert_Answer', // params: roomId: string, answer: string (dismiss, no, yes)
  ClinchGameErrorFinishAlertView = 'ClinchGame_ErrorFinishAlert_View', // params: roomId: string
  ClinchGameErrorFinishAlertAnswer = 'ClinchGame_ErrorFinishAlert_Answer', // params: roomId: string, answer: string (dismiss, no, yes)
  ClinchGameRetryAlertView = 'ClinchGame_RetryAlert_View', // params: roomId: string
  ClinchGameRetryAlertAnswer = 'ClinchGame_RetryAlert_Answer', // params: roomId: string, answer: string (ok)
  ClinchGameFatalAlertView = 'ClinchGame_FatalAlert_View', // params: roomId: string
  ClinchGameFatalAlertAnswer = 'ClinchGame_FatalAlert_Answer', // params: roomId: string, answer: string (ok)
  ClinchGameScoreNotSubmittedAlertView = 'ClinchGame_ScoreNotSubmittedAlert_View', // params: roomId: string
  ClinchGameScoreNotSubmittedAlertAnswer = 'ClinchGame_ScoreNotSubmittedAlert_Ans', // params: roomId: string, answer: string (ok)
  ClinchGameNoHintsAlertView = 'ClinchGame_NoHintsAlert_View', // params: roomId: string
  ClinchGameNoHintsAlertAnswer = 'ClinchGame_NoHintsAlert_Answer', // params: roomId: string, answer: string (dismiss, ok)
  ClinchGameViewInit = 'ClinchGame_ViewInit',

  // Clinch Game
  ClinchGameLoaded = 'ClinchGameLoaded',
  ClinchGameStartRoom = 'ClinchGame_StartRoom',
  ClinchGameDiscloseSecrets = 'ClinchGameDiscloseSecrets',
  ClinchGameDiscloseSecretsFailed = 'ClinchGameDiscloseSecretsFailed',

  // Match Options
  LightningPayDrawView = 'LightningPayDraw_View',
  NativePayDrawView = 'NativePayDraw_View',
  OperatorLightningPayDrawView = 'OperatorLightningPayDraw_View',
  WaitingForPaymentDrawView = 'WaitingForPaymentDraw_View',
  CheckingPaymentsDrawView = 'CheckingPaymentsDraw_View',

  // Loading View
  LoadingStart = 'Loading_Start',
  LoadingFinish = 'Loading_Finish',

  // UX
  CopyFailed = 'Copy_Failed',

  // Moves
  SetMovesError = 'SetMoves_Error',

  // Game Tab
  GameTabViewed = 'GameTabViewed',
  DecreasePrizeButtonClicked = 'DecreasePrizeButtonClicked',
  IncreasePrizeButtonClicked = 'IncreasePrizeButtonClicked',
  SelectTier = 'SelectedTier',
  ChangePrizeButtonClicked = 'ChangePrizeButtonClicked',
  PlayButtonClicked = 'PlayButtonClicked',
  PracticeButtonClicked = 'PracticeButtonClicked',
  MatchFinished = 'MatchFinished',
  PracticeMatchFinished = 'PracticeMatchFinished',
  SubmitScore = 'SubmitScore', // params: roomId: string, moves: string, context: string

  // Payment Drawer
  PaymentDrawerViewed = 'PaymentDrawerViewed',
  PaymentDrawerClosed = 'PaymentDrawerClosed',
  PaymentDrawerPayButtonClicked = 'PaymentDrawerPayButtonClicked',
  PracticeDrawerViewed = 'PracticeDrawerViewed',
  PracticeDrawerClosed = 'PracticeDrawerClosed',
  PracticeDrawerPlayButtonClicked = 'PracticeDrawerPlayButtonClicked',

  // Results
  ResultsTabViewed = 'ResultsTabViewed',
  MyResultsViewed = 'MyResultsViewed',
  WorldwideResultsViewed = 'WorldwideResultsViewed',

  // Results Drawer
  ResultDrawerWinViewed = 'ResultDrawerWinViewed',
  ResultDrawerLossViewed = 'ResultDrawerLossViewed',
  ResultDrawerDrawViewed = 'ResultDrawerDrawViewed',
  ResultDrawerCancelledViewed = 'ResultDrawerCancelledViewed',
  ResultDrawerInProgressViewed = 'ResultDrawerInProgressViewed',

  // Leaderboards
  LeaderboardTabViewed = 'LeaderboardTabViewed',
  MostWinsDailyLeaderboardViewed = 'MostWinsDailyLeaderboardViewed',
  MostWinsWeeklyLeaderboardViewed = 'MostWinsWeeklyLeaderboardViewed',
  MostWinsMonthlyLeaderboardViewed = 'MostWinsMonthlyLeaderboardViewed',
  MostWinsAllTimeLeaderboardViewed = 'MostWinsAllTimeLeaderboardViewed',
  TopEarnersDailyLeaderboardViewed = 'TopEarnersDailyLeaderboardViewed',
  TopEarnersWeeklyLeaderboardViewed = 'TopEarnersWeeklyLeaderboardViewed',
  TopEarnersMonthlyLeaderboardViewed = 'TopEarnersMonthlyLeaderboardViewed',
  TopEarnersAllTimeLeaderboardViewed = 'TopEarnersAllTimeLeaderboardViewed',

  // Tournament Tab
  TournamentTabViewed = 'TournamentTabViewed',

  // Rules Tab
  RulesTabViewed = 'RulesTabViewed',

  // Stats
  StatsDrawerViewed = 'StatsDrawerViewed',
}

export function isOperatorEventName(event: string): boolean {
  const filter = [
    EventName.GameTabViewed,
    EventName.ResultsTabViewed,
    EventName.LeaderboardTabViewed,
    EventName.TournamentTabViewed,
    EventName.RulesTabViewed,
    EventName.MyResultsViewed,
    EventName.WorldwideResultsViewed,
    EventName.MostWinsDailyLeaderboardViewed,
    EventName.MostWinsWeeklyLeaderboardViewed,
    EventName.MostWinsMonthlyLeaderboardViewed,
    EventName.MostWinsAllTimeLeaderboardViewed,
    EventName.TopEarnersDailyLeaderboardViewed,
    EventName.TopEarnersWeeklyLeaderboardViewed,
    EventName.TopEarnersMonthlyLeaderboardViewed,
    EventName.TopEarnersAllTimeLeaderboardViewed,
    EventName.MatchFinished,
    EventName.PracticeMatchFinished,
    EventName.ResultDrawerWinViewed,
    EventName.ResultDrawerLossViewed,
    EventName.ResultDrawerDrawViewed,
    EventName.ResultDrawerCancelledViewed,
    EventName.ResultDrawerInProgressViewed,
    EventName.StatsDrawerViewed,
  ];
  return filter.includes(event as EventName);
}

export enum EventParam {
  Open = 'open',
  Close = 'close',
  Dismiss = 'dismiss',
  Yes = 'yes',
  No = 'no',
  Ok = 'ok',
}
